export function expandText() {
    const expandText = $(".expanded-text-content");
    const toggler = expandText.find(".more button");
    toggler.on("click", function () {
        let $this = $(this);
        let selfParent = $this.parents(".more");
        selfParent.toggleClass("active");
        selfParent.siblings(".hidden-content").toggleClass("show");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/expand-text.js